module.exports = __webpack_public_path__ + "static/media/contacts.48cae6da.jpg";